<!-- 个人中心 -->
<template>
  <div class="userCenter">
    <div style="width: 1920px;height: 300px;margin: 0 auto;">
      <img style="width: 1920px;height: 300px;margin: 0 auto;margin-top: -1px;z-index: 99" src="../../assets/img/personalCenter/userCenterBanner.png" alt="">
    </div>
    <div class="content">
      <div class="left">
        <div class="userInfo">
          <div class="headImg">
            <img style="width: 100%;height: 100%" :src="userData && userData.headImg ? $winpowUrl + userData.headImg : defaultHeadImg" alt="">
          </div>
          <div class="userName">{{ userData && userData.userName }}</div>
          <div class="accountSafe">
            上次登录:&nbsp;&nbsp;&nbsp;{{ userData && userData.lastLoginTime }}<br>
            <span>登录次数:&nbsp;&nbsp;&nbsp;<span style="color: #FF2F2F;">{{ userData && userData.loginNum ? userData.loginNum : 0 }}次</span></span><br>
            帐号安全:&nbsp;&nbsp;
            <div class="progressBar">
              <div class="inner" :class="{on: userData && userData.userName}" />
            </div>
            <span class="level" :class="{on: userData && userData.userName}">{{ userData && userData.userName ? '高' : '低' }}</span>
          </div>
        </div>
        <div class="menu">
          <div class="menuTop">
            <img class="userCenterIcon" src="../../assets/img/personalCenter/userCenter.png" alt="">
            <img class="notice" :src="activePage == 5 || activeHoverId == 5 ? require('../../assets/img/personalCenter/noticeOn.png') : require('../../assets/img/personalCenter/notice.png')" alt="" @click="activePage = 5, activeHoverId = 5" @mouseenter="activeHoverId = 5" @mouseleave="activeHoverId = 0">
            <div v-if="unread" class="noticeCount">{{ unread }}</div>
            个人中心
          </div>
          <template v-for="item in menuList">
            <div :key="item.id" class="menuItem" :class="{on: activeHoverId === item.id || activePage === item.id}" @click="handleMenuClick(item.id)" @mouseenter="activeHoverId = item.id" @mouseleave="activeHoverId = 0">
              <div class="leftBar" />
              <img class="menuIcon" :src="activeHoverId === item.id || activePage === item.id ? item.src2 : item.src" alt="">
              {{ item.name }}
            </div>
            <template v-if="item.children">
              <template v-for="child in item.children">
                <div v-if="child.name !== '公司成员' || (userData && userData.companyPkid)" :key="child.id" class="childMenu" :class="{on: activeChildHoverId === child.id || activeChildPage === child.id}" @click="childMenuItemChange(child.id,item.id)" @mouseenter="activeChildHoverId = child.id" @mouseleave="activeChildHoverId = 0">
                  {{ child.name }}
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
      <div class="right">
        <div class="mainArea" :class="{ listArea: $route.hash && $route.hash !== '#userHome'}">
          <Component :is="activeComponent" :company-info="companyInfo" :message-list="messageList" :activity-list="activityList" @jumpTo="jumpTo" @getNoRead="getNoRead" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import enterprise from './mainPage/Enterprise'
import companyMember from './mainPage/CompanyMember'
import userCenterHome from './mainPage/UserCenterHome'
import personInfo from './mainPage/PersonInfo'
import activityRecords from './mainPage/ActivityRecords'
import collectTutor from './mainPage/CollectTutor'
import collectCourse from './mainPage/CollectCourse'
import collectActivity from './mainPage/CollectActivity'
import message from './mainPage/Message'
import { mapState } from 'vuex'
export default {
  name: 'UserCenter',
  components: {
    companyMember,
    enterprise,
    userCenterHome,
    personInfo,
    activityRecords,
    collectCourse,
    collectActivity,
    collectTutor,
    message
  },
  data () {
    return {
      unread: 0,
      activityList: [],
      messageList: [],
      companyInfo: {},
      activeComponent: userCenterHome,
      childPath: {
        '1': '',
        '21': '',
        '22': '',
        '23': '',
        '3': '',
        '41': '',
        '42': '',
        '43': ''
      },
      animate: false,
      loginTimes: 50,
      lastLoginTime: '2021-09-11 16:15',
      activeHoverId: 1,
      activePage: 1,
      activeChildHoverId: 0,
      activeChildPage: 0,
      defaultHeadImg: require('../../assets/img/personalCenter/head.png'),
      menuList: [
        {
          id: 1,
          name: '首页',
          src: require('../../assets/img/personalCenter/homepage.png'),
          src2: require('../../assets/img/personalCenter/homepageOn.png')
        },
        {
          id: 2,
          name: '基本信息',
          src: require('../../assets/img/personalCenter/basicInfo.png'),
          src2: require('../../assets/img/personalCenter/basicInfoOn.png'),
          children: [
            {
              id: 21,
              name: '个人信息'
            },
            {
              id: 25,
              name: '修改密码'
            },
            {
              id: 26,
              name: '修改手机号'
            },
            {
              id: 22,
              name: '企业信息'
            },
            {
              id: 23,
              name: '公司成员'
            }
          ]
        },
        {
          id: 3,
          name: '活动记录',
          src: require('../../assets/img/personalCenter/activityRecords.png'),
          src2: require('../../assets/img/personalCenter/activityRecordsOn.png')
        },
        {
          id: 4,
          name: '我的收藏',
          src: require('../../assets/img/personalCenter/myCollect.png'),
          src2: require('../../assets/img/personalCenter/myCollectOn.png'),
          children: [
            {
              id: 41,
              name: '收藏课程'
            },
            {
              id: 42,
              name: '收藏活动'
            },
            {
              id: 43,
              name: '收藏导师'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState(['userData']),
    userCheck () {
      const params = ['userName', 'gender', 'peopleDuty', 'phone', 'contactAddress']
      let flag = true
      params.forEach(item => {
        if (this.userData && !this.userData[item]) {
          flag = false
        }
      })
      return flag
    },
    pageNumber () {
      if (this.activePage === 2 || this.activePage === 4) {
        if (this.activeChildPage !== 0) {
          return this.activeChildPage
        } else {
          return this.activePage
        }
      } else {
        return this.activePage
      }
    }
  },
  watch: {
    $route (val) {
      const topH1 = document.getElementsByClassName('userInfo')[0]
      document.documentElement.scrollTop = topH1.offsetTop
      window.pageYOffset = topH1.offsetTop
      document.body.scrollTop = topH1.offsetTop
    },
    pageNumber (val, oldVal) {
      const data = {
        1: userCenterHome, 21: personInfo, 22: enterprise, 23: companyMember,
        3: activityRecords, 41: collectCourse, 42: collectActivity, 43: collectTutor, 5: message
      }
      if (val === 2 || val === 4) {
        this.activeComponent = data[oldVal]
      } else {
        this.activeComponent = data[val]
        window.location.hash = this.childPath[val]
      }
    }
  },
  created () {
    this.getData()
    this.getNoRead()
    if (window.location.hash) {
      for (const key in this.childPath) {
        if (this.childPath[key] === window.location.hash.replace('#', '')) {
          if (key === '21' || key === '22' || key === '23') {
            this.activePage = 2
            this.activeChildPage = Number(key)
            this.activeHoverId = Number(key)
          } else if (key === '41' || key === '42' || key === '43') {
            this.activePage = 4
            this.activeChildPage = Number(key)
            this.activeHoverId = Number(key)
          } else {
            this.activePage = Number(key)
            this.activeHoverId = Number(key)
          }
        }
      }
    }
  },
  mounted () {
    if (this.userData && !this.userData.companyPkid) {
      this.$confirm('用户未关联企业，点击确认关联企业', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.$bus.$emit('candleSSo', 8, 'window')
        // window.open(this.$winpowUrl + '/usercenter/getQiyeinfo.html?qiye.t=v')
      }).catch(() => { })
    }
  },
  methods: {
    childMenuItemChange (childId, itemId) {
      if (childId == 25) {
        // 修改密码
        this.$bus.$emit('candleSSo', 6, 'window')
      } else if (childId == 26) {
        // 修改手机号
        this.$bus.$emit('candleSSo', 7, 'window')
      } else if (childId == 23) {
        this.$bus.$emit('candleSSo', 9, 'window')
      } else {
        this.activeChildPage = childId
        this.activePage = itemId
      }
    },
    getNoRead () {
      this.$get('/front/userCenter/unread').then(res => {
        this.unread = res
      })
    },
    getData () {
      this.$get('/front/userCenter/index').then(res => {
        if (res) {
          this.companyInfo = res.company
          this.activityList = res.activity
          this.messageList = res.message
        }
      })
    },
    jumpTo (index) {
      this.activePage = index
    },
    handleMenuClick (id) {


      this.activeChildPage = 0
      this.activePage = id

    }
  }
}
</script>

<style lang="scss"  scoped>
.userCenter {
  background-color: #f6f6f5;
  color: #333333;
  .content {
    margin: 0 auto;
    padding: 10px 0 50px 0;
    width: 1200px;
    .left {
      display: inline-block;
      width: 300px;
      .userInfo {
        position: relative;
        width: 300px;
        height: 283px;
        background: #ffffff;
        box-shadow: 0 0 8px 0 rgba(51, 51, 51, 0.1);
        border-radius: 10px;
        overflow: hidden;
        .headImg {
          width: 100px;
          height: 100px;
          margin: 30px 0 0 100px;
          border-radius: 50px;
          overflow: hidden;
        }
        .userName {
          width: 100%;
          height: 30px;
          line-height: 40px;
          color: #ea5504;
          font-size: 20px;
          text-align: center;
        }
        .accountSafe {
          width: 240px;
          margin: 18px auto;
          line-height: 30px;
          .progressBar {
            vertical-align: middle;
            display: inline-block;
            width: 130px;
            height: 6px;
            background: #f6f6f5;
            border-radius: 3px;
            .inner {
              width: 40px;
              height: 6px;
              background: #ff0000;
              border-radius: 3px;
            }
            .inner.on {
              width: 130px;
              background: #ea5504;
            }
          }
          .level {
            margin-left: 10px;
            font-size: 14px;
            color: #ff0000;
          }
          .level.on {
            color: #ea5504;
          }
        }
      }
      .menu {
        width: 300px;
        min-height: 521px;
        margin-top: 10px;
        font-size: 18px;
        background: #ffffff;
        box-shadow: 0 0 8px 0 rgba(51, 51, 51, 0.1);
        border-radius: 10px;
        overflow: hidden;
        .menuTop {
          position: relative;
          width: 100%;
          height: 64px;
          line-height: 64px;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          text-align: center;
          border-bottom: 1px #ea5504 dashed;
          img {
            vertical-align: middle;
          }
          .userCenterIcon {
            margin-right: 10px;
            margin-bottom: 3px;
          }
          .notice {
            float: right;
            margin-top: 23px;
            margin-right: 15px;
            cursor: pointer;
          }
          .noticeCount {
            position: absolute;
            top: 15px;
            right: 10px;
            width: 15px;
            height: 15px;
            line-height: 15px;
            color: #ffffff;
            font-size: 12px;
            border-radius: 50%;
            background-color: #ff0000;
          }
        }
        .menuItem.on {
          color: #ea5504;
          .leftBar {
            opacity: 1;
          }
        }
        .menuItem {
          width: 100%;
          height: 30px;
          margin-top: 25px;
          line-height: 30px;
          cursor: pointer;
          vertical-align: middle;
          font-size: 16px;
          .leftBar {
            width: 4px;
            height: 30px;
            background: #ea5504;
            border-radius: 2px;
            float: left;
            opacity: 0;
          }
          .menuIcon {
            margin: -5px 22px 0 45px;
            vertical-align: middle;
          }
        }
        .childMenu {
          width: 100%;
          height: 25px;
          line-height: 25px;
          margin-top: 10px;
          padding-right: 115px;
          text-align: right;
          cursor: pointer;
          box-sizing: border-box;
          font-size: 16px;
        }
        .childMenu.on {
          color: #ea5504;
        }
      }
    }
    .right {
      vertical-align: top;
      display: inline-block;
      width: 890px;
      margin-left: 10px;
      .mainArea {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .mainArea.listArea {
        padding: 30px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 0.1);
      }
    }
  }
}
</style>
